const initialState = {
  userId: '',
  cloneFrom: '',
  memberCk: '',
  subscriberCk: '',
  groupCk: '',
  groupId: '',
  subGroupCk: '',
  parentGroupCk: '',
  originatingUserId: '',
  primarySubscriberMemberCk: '',
  invoiceNumber: '',
  classId: '',
  planId: '',
  dateOfService: ''
}

const state = { ...initialState }
const mutations = {
  // Partial state update mutation
  UPDATE_HIDDEN_ROUTE_PARAMS_STATE(state, data) {
    // Reset state to initial state
    Object.keys(state).forEach(key => {
      // If a key in data exists, update it; otherwise, reset it
      if (data.hasOwnProperty(key)) {
        state[key] = data[key];
      } else {
        state[key] = initialState[key]; // Reset to initial state value
      }
    })
  },
  // Clear state mutation
  CLEAR_HIDDEN_ROUTE_PARAMS_STATE(state) {
    Object.assign(state, initialState) // Reset all properties to initial values
  }
}
const actions = {
  updateHiddenRouteParamsState({ commit }, data) {
    commit('UPDATE_HIDDEN_ROUTE_PARAMS_STATE', data)
  },
  clearHiddenRouteParamsState({ commit }) {
    commit('CLEAR_HIDDEN_ROUTE_PARAMS_STATE')
  }
}
const getters = {
  getHiddenRouteData: state => state
}

export const hiddenRouteData = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
